import MsftLandingPage from './MsftLandingPage'

export default MsftLandingPage
